import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getPartyQueryKey } from "Api/Queries/Party/usePartyQuery";
import { deletePartiesPublicIDAddressesAddressID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  partyPublicID: string;
  onSuccess?: () => void;
  onError?: () => void;
};

type Variables = {
  addressID: number;
};

export const useDeletePartyAddressMutation = ({
  partyPublicID,
  onSuccess,
  onError,
}: Props) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ addressID }: Variables) =>
        deletePartiesPublicIDAddressesAddressID(partyPublicID, addressID),
    ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: getPartyQueryKey(partyPublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
